export const TRY_AGAIN = "Please try again.";
export const FAILURE_MESSAGE = "Sorry, there's been a problem.";
export const EMAIL_SUCCESS_MESSAGE =
  "If this email address exists an email with instructions to reset your password will be sent to it.";

export const REQUIRED_MESSAGE = "This field is required";
export const INVALID_EMAIL_MESSAGE = "Email address is invalid";
export const EMAIL_IS_REQUIRED_MESSAGE = "Email address is required";
export const CONFIRM_EMAIL_MESSAGE = "Email address doesn't match";
export const PASSWORD_MESSAGE =
  "Your password does not meet our required criteria";
export const CONFIRM_PASSWORD_MESSAGE = "Passwords don't match";
export const FIRST_NAME_MESSAGE = "First name is invalid";
export const LAST_NAME_MESSAGE = "Last name is invalid";
export const TERMS_MESSAGE = "You have to agree to the terms and conditions";
export const MOBILE_NUMBER_MESSAGE = "Please provide a valid phone number";

export const EMAIL_IN_USE =
  "You already have an account with us. Please login.";
export const CHECK_EMAIL_ERR =
  "Unfortunately, there was a problem.\n\nPlease try again later.";
export const CHECK_FIRST_LAST_NAME =
  "Unfortunately, there has been an error in the request.\n\nPlease check first name and last name and try again.";

export const WEBAUTHN_ALREADY_REGISTERED =
  "Unfortunately we were unable to register this device. Please ensure it was not previously registered.";

export const WEBAUTHN_ASSERTION_ERROR =
  "It was not possible to log into your account using these details.";
